export interface TimeZoneOption {
  id: string;
  label: string;
}

export function buildTimeZoneCatalog(): Map<string, TimeZoneOption[]> {
  const source =
    typeof Intl.supportedValuesOf === 'function'
      ? Intl.supportedValuesOf('timeZone')
      : ['UTC', 'Europe/Chisinau', 'Europe/Berlin', 'Europe/London', 'America/New_York'];
  const allowedRegions = new Set([
    'Africa',
    'America',
    'Antarctica',
    'Asia',
    'Atlantic',
    'Australia',
    'Europe',
    'Indian',
    'Pacific',
    'Etc',
  ]);
  const catalog = new Map<string, TimeZoneOption[]>();

  for (const timeZone of source) {
    const [region] = timeZone.split('/');
    if (!allowedRegions.has(region)) {
      continue;
    }

    const options = catalog.get(region) ?? [];
    options.push({
      id: timeZone,
      label: formatTimeZoneLabel(timeZone),
    });
    catalog.set(region, options);
  }

  if (!catalog.has('Etc')) {
    catalog.set('Etc', [{ id: 'UTC', label: 'UTC' }]);
  } else if (!(catalog.get('Etc') ?? []).some((item) => item.id === 'UTC')) {
    catalog.get('Etc')?.unshift({ id: 'UTC', label: 'UTC' });
  }

  for (const options of catalog.values()) {
    options.sort((left, right) => left.label.localeCompare(right.label));
  }

  return new Map([...catalog.entries()].sort(([left], [right]) => left.localeCompare(right)));
}

export function findTimeZoneRegion(
  catalog: Map<string, TimeZoneOption[]>,
  timeZone: string,
): string {
  for (const [region, items] of catalog.entries()) {
    if (items.some((item) => item.id === timeZone)) {
      return region;
    }
  }

  return 'Etc';
}

function formatTimeZoneLabel(timeZone: string): string {
  const parts = timeZone.split('/');
  if (parts.length <= 1) {
    return timeZone.replace(/_/g, ' ');
  }

  return parts.slice(1).join(' / ').replace(/_/g, ' ');
}
